import "draft-js/dist/Draft.css";
import "@draft-js-plugins/emoji/lib/plugin.css";

import { Editor, EditorState, Modifier, RichUtils, SelectionState, getDefaultKeyBinding } from "draft-js";
import { notification } from 'antd'
import React, { useEffect, useRef, useState } from "react";

import { ChatActions } from "../../../../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../../../../base/models/model";
import { excelFormats, hassAccess, imageFormat, mp3Formats, pdfFormats, pptFormats, videoFormat, wordFormats } from "../../../../../base/utils";
import { GetItemFromStorage } from "../../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../../custom_hooks/localStorageKeys";
import Picker from "@emoji-mart/react";
import { Button, Dropdown, Modal, Select, Tooltip } from "antd";
import { SyntheticKeyboardEvent } from "react-draft-wysiwyg";
import Wordicon from "../../../../../styles/images/fileword.svg";
import Excelicon from "../../../../../styles/images/fileexcel.svg";
import Pdficon from "../../../../../styles/images/filepdf.svg";
import fileppt from "../../../../../styles/images/fileppt.svg";
import xdicon from "../../../../../styles/images/xdicoagentn.svg";
import filezip from "../../../../../styles/images/filezip.svg";

import callChatService from "../../../../../base/service/chatService";
import chatattachfont from "../../../../../styles/images/chatattach.svg";
import chatboldfont from "../../../../../styles/images/chatbold.svg";
import chatitalicfont from "../../../../../styles/images/chatitalic.svg";
import chatlinkfont from "../../../../../styles/images/chatlink.svg";
import chatnumberfont from "../../../../../styles/images/chatnumberlist.svg";
import chatorderfont from "../../../../../styles/images/chatorderlist.svg";
import chatsmilefont from "../../../../../styles/images/chatsmile.svg";
import chatsmilecenter from "../../../../../styles/images/smiley.svg";
import chatstrikefont from "../../../../../styles/images/chatstrike.svg";
import { config, CONTACT_CENTRE_PLAN_ID } from "../../../../../base/constant";
import { convertToHTML } from "draft-convert";
import data from "@emoji-mart/data";
import jwt_decode from "jwt-decode";
import styles from "../chatMainInner.module.scss";
import { useDispatcher } from "../../../../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
// import { Select } from 'antd';
import type { MenuProps, SelectProps } from 'antd';
import { CoreServices, EmailServices, SmsServices, SocialmediaServices, WhatsappService } from "../../../../../base/service/apiServices";
import ReactQuill from "react-quill";
import Loader from "../../../../../shared/widges/Loader/loader";
import Loaders from "../../../../../components/loader/loader";
import axios from "axios";
import Dragger from "antd/lib/upload/Dragger";
import { getNecessaryDetailswithsession } from "../../../../../store/api/helperspi/contactListapiService";
import _ from "lodash";
import UpgradeTranscription from "../../../../../shared/widges/upgrademodal/upgradetranscription";
import Internalupgrade from "../../../../../shared/widges/upgrademodal/internalupgrade";
import { checkCurrentSessionChannel } from "../../../utils";
import { getSentimentalCustomer_chat } from "../../../../../store/helpers/nlpapi";
const { Option } = Select;
const options: SelectProps['options'] = [];
const ChatEditorBottom = (props: any) => {
  // let cookieData: any = Cookie.get();

  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  let LoginUserDetails: any = jwt_decode(accessToken);
  const agentId = `${LoginUserDetails?.domain_id}_${LoginUserDetails?.ext}`;
  const [emojiModalVisible, setEmojiModalVisible] = useState(false);
  const dispatch = useDispatcher();
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [fileSrc, setFileSrc] = useState<any>("");
  const [fileType, setFileType] = useState<any>('');
  const [uploadFile, setUploadFile] = useState<any>('');
  const [attachFile, setAttachmentFile] = useState<any>([]);
  const editorRef = useRef<Editor>(null);
  const emojiButtonRef = useRef<HTMLButtonElement>(null);
  const emojiModalRef = useRef<HTMLDivElement>(null);
  const [closeFile, setCloseFile] = useState(false);
  const [mailState, setMailState] = useState<any>({ ccState: false, bccState: false });
  const [toMailList, setToMailList] = useState<any>([])
  const [filename, setFilename] = useState<any>("");
  const [subject, setSubject] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const [ccEmail, setCcEmail] = useState<any>([])
  const [bccEmail, setBccEmail] = useState<any>([])
  const [textQuill, setTextQuil] = useState<any>("");
  const [textMessage, setMessageInfo] = useState<any>("");
  const [error, setError] = useState<any>("");

  let { currentSession, currentSessionMsgHistory } = chatReducer;
  const isTransfer = useSelector((state: any) => state.chatReducer.isTransfer);
  const supervisorData = useSelector((state: any) => state.supervisorData);
  let { internalSessionId } = chatReducer;
  let message: any = useSelector((state: any) => state.chatReducer.message);
  let type: any = useSelector((state: any) => state.chatReducer.typeOfMessage);
  const [activeButton, setActiveButton] = useState<any>({
    bold: false,
    italic: false,
    strikethrough: false,
    link: false,
    unordered_list: false,
    ordered_list: false,
    activeBtn: ""
  });
  const mp3Formats_ = currentSession.channelType !== "Whatsapp" ? mp3Formats : ['audio/mp3', 'mp3']

  useEffect(() => {
    if (props.sms_email?.[0] === 'email') {
      try {
        const email = props.sms_email?.[1] ?? ''
        setToMailList([email])
      } catch (error) { console.log(error) }
    }
  }, [props.sms_email])

  useEffect(() => {
    const textClr: any = document.getElementById('textedited');
    if (textClr) {
      // textClr.textContent = textClr?.textContent ? textClr?.textContent : "";
      // textClr.innerHTML = textClr?.textContent ? textClr?.textContent : "";
      textClr.focus();
      setMessageInfo(textClr?.innerHTML);
      dispatch(ChatActions.setEditState(false));
    }

  }, [chatReducer?.isEditState])

  useEffect(() => {
    if (currentSession.channelType === 'Email')
      setToMailList([currentSession.FromEmail]);

    if (editorRef?.current) {
      const selectionState = SelectionState.createEmpty(editorState.getCurrentContent().getFirstBlock().getKey()); // create an empty selectionState at the start of the first block
      const updatedSelection = selectionState.merge({
        anchorOffset: editorState.getSelection().getAnchorOffset(), // set the anchorOffset to the current cursor position
        focusOffset: editorState.getSelection().getFocusOffset(), // set the focusOffset to the current cursor position
      });
      const updatedEditorState = EditorState.forceSelection(editorState, updatedSelection); // create a new editor state with the updated selection
      setEditorState(updatedEditorState); // set the updated editor state
      editorRef?.current?.focus(); // set the focus at the updated selection
    }
  }, [currentSession]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        emojiModalVisible &&
        emojiButtonRef?.current &&
        emojiModalRef?.current &&
        !emojiButtonRef?.current.contains(event.target as Node) &&
        !emojiModalRef?.current.contains(event.target as Node)
      ) {
        setEmojiModalVisible(false);
      }
    };
    if (editorRef?.current) {
      editorRef?.current?.focus(); // set the focus at the updated selection
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiModalVisible]);
  const toggleEmojiPicker = () => {
    setEmojiModalVisible(!emojiModalVisible);
  };
  const close = () => {
    setEmojiModalVisible(false);
  };
  const open = () => {
    setEmojiModalVisible(!emojiModalVisible);
  };

  const selectMessage = (e: any) => {
    const selectedEmoji = e.native;
    const contentEditableDiv = document.getElementById('textedited');
    if (contentEditableDiv) {
      contentEditableDiv.innerHTML += selectedEmoji;
      setMessageInfo(contentEditableDiv.innerHTML)
    }
  };

  const Cancel = (e: any) => {
    setCloseFile(!closeFile);
    e.target.value = "";
    setFileSrc(e.target.value);
    setAttachmentFile([]);
  };


  const clearMessage = (messageContent: any) => {
    callChatService.webChatMessage(messageContent);

    setEditorState(EditorState.createEmpty());
    setFileSrc("");
    setFileType([]);
    setUploadFile("");
    setAttachmentFile([]);

    const textClr: any = document.getElementById('textedited');
    if (textClr !== '') {
      textClr.textContent = "";
      textClr.innerHTML = "";
      textClr.focus();
      setMessageInfo('');
    }
  }

  const sendMessageChat = (e: any) => {
    if (type === "file") {
      if (uploadFile === "") {
        return;
      }
      let messageContent: any = {
        messageID: uuidv4(),
        from: agentId,
        sessionId: currentSession?.sessionId,
        to: currentSession?.sessionId,
        messageType: "file",
        message: attachFile[0],
        sender: { uuid: LoginUserDetails?.uuid, Name: LoginUserDetails?.profileName, Email: LoginUserDetails?.username },
        isBot: false,
        isCustomer: false,
        ChatHistoryId: parseInt(currentSession?.ChatHistoryId),
        ChatDurationHistoryId: parseInt(currentSession?.ChatDurationHistoryId),
        sendAt: Date.now(),
        supervisorList: chatReducer?.supervisorList
      };

      if (currentSession?.supervisorStatus === 'whisper' && (loginUserCcaasDetail?.roleid == '5' || loginUserCcaasDetail?.roleid == '3')) {
        messageContent.from = agentId;
        messageContent.whisper = true;
        messageContent.to = `${LoginUserDetails?.domain_id}_${currentSession?.agentExt}`;
        messageContent.socketId = currentSession?.sessionId;
        messageContent.showWhisper = true;
        clearMessage(messageContent);
        return;
      }

      clearMessage(messageContent);
      dispatch(ChatActions.agentAddMessage(messageContent));
      dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "" }));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(messageContent));
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_chat(messageContent, dispatch);
      }    
    } else {
      if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim()) {
        return;
      }

      let data = convertContentToHTML(editorState.getCurrentContent());
      let messageContent: any = {
        messageID: uuidv4(),
        from: agentId,
        to: currentSession?.sessionId,
        sessionId: currentSession?.sessionId,
        message: textMessage?.trim(),
        sender: { uuid: LoginUserDetails?.uuid, Name: LoginUserDetails?.profileName, Email: LoginUserDetails?.username },
        isBot: false,
        isCustomer: false,
        messageType: "Text",
        sendAt: Date.now(),
        ChatHistoryId: parseInt(currentSession?.ChatHistoryId),
        ChatDurationHistoryId: parseInt(currentSession?.ChatDurationHistoryId),
        supervisorList: chatReducer?.supervisorList
      };

      if (currentSession?.supervisorStatus === 'whisper' && (loginUserCcaasDetail?.roleid == '5' || loginUserCcaasDetail?.roleid == '3')) {
        messageContent.from = agentId;
        messageContent.whisper = true;
        messageContent.to = `${LoginUserDetails?.domain_id}_${currentSession?.agentExt}`;
        messageContent.socketId = currentSession?.sessionId;
        messageContent.showWhisper = true;
        clearMessage(messageContent);
        // dispatch(ChatActions.agentAddMessage(messageContent));
        return;
      }

      const nlpData = { ...messageContent, agentId: messageContent.from }
      if (hassAccess('sentimentalAnalysis')){
        getSentimentalCustomer_chat(nlpData, dispatch);
      }
      clearMessage(messageContent);
      dispatch(ChatActions.agentAddMessage(messageContent));
      dispatch(ChatActions.storeCurrentSessionMsgHistory(messageContent));
      dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "" }));
      resetActiveButtons();

    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();

      if (!currentSession) return;

      if (currentSession.ChatHistoryId && currentSession.Istransferred !== 1 && props?.sms_email === null) {
        sendMessageChat(e);
      } else if (currentSession.channelType === 'Sms' || props.sms_email?.[0] === 'sms') {
        props.sms_email?.[0] === 'sms' ? sendOutBoundSMS() : sendSms();
      } else if (currentSession.channelType === 'Email' || props.sms_email?.[0] === 'email') {
        props.sms_email?.[0] === 'email' ? sendOutBoundEMAIL(e) : btnSendEmail(e);
      } else if (currentSession.channelType === 'Whatsapp' && currentSession.callBack !== 1) {
        sendWhatsapp();
      } else if (currentSession.channelType === 'Facebook' && currentSession.callBack !== 1) {
        sendFacebook();
      } else if (currentSession.channelType === 'Instagram' && currentSession.callBack !== 1) {
        sendInstagram();
      }
    }
  };


  const getChatMessageValue = (e: any) => {
    dispatch(ChatActions.updateAddAgentMessage(e.target.value));
  };

  const handleKeyCommand = (command: string, editorState: EditorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return "handled";
    }
    return "not-handled";
  };

  const mapKeyToEditorCommand = (e: SyntheticKeyboardEvent): string | null => {
    if (e.key === "Tab") {
      const newEditorState = RichUtils.onTab(e, editorState, 4 /* maxDepth */);
      if (newEditorState !== editorState) {
        setEditorState(newEditorState);
      }
      return null;
    }
    return getDefaultKeyBinding(e);
  };
  const toggleInlineStyle = (inlineStyle: string) => {
    if (editorRef?.current) {
      editorRef?.current?.focus();
    }
    setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle));
    dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "text" }));
    // dispatch(ChatActions.updateAddAgentMessage({ message: "text" }))
  };

  const toggleBlockType = (blockType: string) => {
    if (editorRef?.current) {
      editorRef?.current?.focus();
    }
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
    dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "text" }));

  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUploadRef = () => {
    fileInputRef.current?.click();
  };

  const handleFileUpload = async (event: any) => {
    try {
      const filevalue = []
      const formData = new FormData();
      for (let file of event.target.files) {
        formData.append("doc", file);
        filevalue.push({
          uid: file?.uid,
          lastModified: file?.lastModified,
          lastModifiedDate: file?.lastModifiedDate,
          name: file?.name,
          size: file?.size,
          type: "file",
          webkitRelativePath: file?.webkitRelativePath,
          fileType: file?.type,
          message: file,
        })
      }


      await EmailServices.post(formData, `/file_upload`).then((res: any) => {
        if (res.data.statusCode === 200) {
          setAttachmentFile((prevState: any) => [...prevState, ...res.data?.fileList])
          setUploadFile(res.data?.fileList[0].url);
          setFilename(event.target.files[0].name);
          setFileType(res.data?.fileList[0].mimetype);
        }
      })
      const reader = new FileReader();

      dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "file" }));
      reader.onload = (e: any) => {
        const dataURL = e.target.result;
        setFileSrc(dataURL);
      };

      reader.readAsDataURL(file);
      if (editorRef?.current) {
        editorRef?.current?.focus();
      }
    } catch (error) {
      console.log(error)
    }

  };
  //console.log(activeButton,"activeButtonactiveButtonactiveButton")
  const inlineStyleButtons = [
    { label: <img src={chatboldfont} style={activeButton.bold === true ? { color: "blue" } : { color: "white" }} alt="B" />, style: "BOLD" },
    { label: <img src={chatitalicfont} style={activeButton.italic === true ? { color: "blue" } : { color: "grey" }} alt="I" />, style: "ITALIC" },
    { label: <img src={chatstrikefont} style={activeButton.strikethrough === true ? { color: "blue" } : { color: "grey" }} alt="strike" />, style: "STRIKETHROUGH" },
    { label: <img src={chatorderfont} style={activeButton.unordered_list === true ? { color: "blue" } : { color: "grey" }} alt="ul" />, style: "insertUnorderedList" },
    { label: <img src={chatnumberfont} style={activeButton.ordered_list === true ? { color: "blue" } : { color: "grey" }} alt="ol" />, style: "insertOrderedList" },
  ];


  const convertContentToHTML = (contentState: any) => {
    return convertToHTML({
      styleToHTML: (style: any) => {
        if (style === "BOLD") {
          return "<b />";
        }
        if (style === "ITALIC") {
          return "<i />";
        }
        if (style === "STRIKETHROUGH") {
          return "<s />";
        }
        if (style === "LINK") {
          return { start: '<a href="#">', end: "</a>" };
        }
        return "";
      },
    })(contentState);
  };

  const onChangeToMailListFun = (value: any) => {
    console.log(value)
    try {
      if (value.length > 0)
        setToMailList(value)
    } catch (error) {
      console.log(error)
    }
  }

  const b64toBlob = (b64Data: any, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  const btnSendEmail = async (e: any) => {
    // if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim())
    // return
    setLoader(true);
    let attachement: any = []
    if (attachFile.length > 0 && uploadFile !== '') {
      for (let data of attachFile) {
        attachement.push({
          filename: data?.filename,
          path: data?.path,
          href: data?.url,
          type: data?.mimetype,
          ...data
        })
      }
    }
    let body = {
      id: uuidv4(),
      fileName: '',
      filePath: '',
      sessionId: currentSession?.sessionId,
      emailHistoryId: currentSession?.EmailHistoryId,
      subject: currentSession.EmailSubject,
      from: currentSession.ToEmail,
      to: toMailList.join(','),
      text: textMessage?.trim(),
      cc: ccEmail.join(','),
      bcc: bccEmail.join(','),
      attachments: attachement,
      messageId: currentSession?.threadMessageId,
      isBot: 0
    }
    let agentBody = {
      agentText: {
        message: {
          to: currentSession.FromEmail,
          from: currentSession.ToEmail,
          sendAt: Date.now(),
          message: textMessage?.trim(),
          subject: currentSession.EmailSubject,
          messageId: currentSession?.threadMessageId,
          attachments: attachement
        }
      }
    }
    EmailServices.post(body, `/send_email`).then((response: any) => {
      if (response && response.data.statusCode === 200) {
        if (Array.isArray(props.customerMsg) && props.customerMsg.length) {
          props.setCustomerMessages(agentBody);
        } else {
          let _temp_array: any = [];
          _temp_array.push(props.customerMsg);
          _temp_array.push(agentBody);
          props.setCustomerMessages(_temp_array, true);
        }
        getCurrentSessionData()
        clearAfterSend()
      }
    }).finally(() => {
      setLoader(false);
      props.onSuccessMailSend()
    })
    resetActiveButtons();
  };
  const sendWhatsapp = async () => {
    try {
      if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() && attachFile.length === 0)
        return
      setLoader(true)
      let providerId: any = "";
      await WhatsappService.get(`/get_whatsapp_provider/${currentSession?.calledNumber}`).then((whatsapp) => {
        if (whatsapp?.data?.getProviderResponse?.length > 0) {
          providerId = whatsapp?.data?.getProviderResponse[0]?.purchasedat ?? null;
        }
      })
      if (attachFile.length > 0) {
        let docx = ''
        if (fileType?.split('/')[1] === 'pdf') {
          docx = "document/pdf"
        } else if (mp3Formats.includes(fileType?.split('/')?.[1])) {
          docx = "audio/mp3"
        } else if (excelFormats.includes(fileType)) {
          docx = "document/xlsx"
        } else if (wordFormats.includes(fileType)) {
          docx = "document/word"
        } else {
          docx = fileType
        }
        const contentTextdata = textMessage?.trim()
          ?.replace(/&nbsp;/g, ' ')
          ?.replace(/<b>(.*?)<\/b>/g, (match: any, group1: any) => `*${group1.trim()}*`)
          ?.replace(/<i>(.*?)<\/i>/g, (match: any, group1: any) => `_${group1.trim()}_`)
          ?.replace(/<strike>(.*?)<\/strike>/g, (match: any, group1: any) => `~${group1.trim()}~`)
        const body = {
          "id": providerId,
          "from": currentSession?.calledNumber.toString(),
          "to": `+${currentSession?.customerNumber.toString()}`,
          "content": contentTextdata,
          "mediaName": filename,
          "mediaUri": uploadFile,
          "mimeType": docx
        }
        axios
          .post(`${config().WHATSAPP_URL}/sendMedia`, body, {
            headers: {
              Authorization: accessToken,
            },
          })
          .then((response: any) => {
            if (response?.data?.status === "Success") {
              whatsppDataToDatabase()
            }
            setLoader(false)
          })
          .catch((error: any) => {
            console.log(error)
            setLoader(false)
            setUploadFile(null)
            setFilename(null)
            setFileType(null)
          })
      } else {
        let temp = textMessage?.trim() || '';
        if (temp.includes('<ul>') && temp.includes('</ul>')) {
          temp = temp.replace(/<ul>/g, '\n').replace(/<\/ul>/g, '');
          temp = temp.replace(/<li>/g, '• ').replace(/<\/li>/g, '\n');
        } else {
          let counter = 1;
          temp = temp.replace(/<p[^>]*>/g, '\n').replace(/<\/p>/g, '');
          temp = temp.replace(/<strong[^>]*>/g, '*').replace(/<\/strong>/g, '*');
          temp = temp.replace(/<b[^>]*>/g, '*').replace(/<\/b>/g, '*');
          temp = temp.replace(/<em[^>]*>/g, '_').replace(/<\/em>/g, '_');
          temp = temp.replace(/<i[^>]*>/g, '_').replace(/<\/i>/g, '_');
          temp = temp.replace(/<s[^>]*>/g, '~').replace(/<\/s>/g, '~');
          temp = temp.replace(/<strike[^>]*>/g, '~').replace(/<\/strike>/g, '~');
          temp = temp.replace(/<ol[^>]*>/g, '\n').replace(/<\/ol>/g, '');
          temp = temp.replace(/<li[^>]*>/g, () => `\n${counter++}. `).replace(/<\/li>/g, '');
        }
        temp = temp.replace(/<\/div>\s*<div>/g, '\n');
        temp = temp.replace(/<div>/g, '').replace(/<\/div>/g, '\n');
        const textData = temp.replace(/<[^>]+>/g, '').trim();
        const body = {
          "id": providerId,
          "from": currentSession?.calledNumber.toString(),
          "to": `+${currentSession?.customerNumber.toString()}`,
          "content": textData
        }
        axios
          .post(`${config().WHATSAPP_URL}/send`, body, {
            headers: {
              Authorization: accessToken,
            },
          })
          .then((response: any) => {
            console.log("response", response)
            if (response?.data?.status === "Success") {
              whatsppDataToDatabase()
            }
            setLoader(false)
          }).catch((error: any) => {
            console.log(error)
            setLoader(false)
          })
      }

    } catch (error) {
      console.log(error)
      setLoader(false)
    }
    resetActiveButtons();
  }
  const whatsppDataToDatabase = () => {
    if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim() && attachFile.length === 0)
      return
    setLoader(true);
    let attachement: any = []
    if (attachFile.length > 0 && uploadFile !== '') {
      for (let data of attachFile) {
        attachement.push({
          filename: data?.filename,
          path: data?.path,
          href: data?.url,
          type: data?.mimetype,
          ...data
        })
      }
    }

    let body = {
      sessionId: currentSession.sessionId,
      whatsappHistoryId: currentSession.WhatsappHistoryId,
      to: currentSession.customerNumber,
      from: currentSession.calledNumber,
      text: textMessage?.trim(),
      attachments: attachement,
      type: "update"
    }
    let agentBody = {
      agentText: {
        message: {
          from: currentSession.calledNumber,
          to: currentSession.customerNumber,
          sendAt: Date.now(),
          message: textMessage?.trim(),
          attachments: attachement,
        }
      }
    }
    WhatsappService.post(body, `/whatsappp_sms_out`).then((response: any) => {
      if (response && response.data.statusCode === 200) {
        if (Array.isArray(props.customerMsg) && props.customerMsg.length) {
          props.setCustomerMessages(agentBody);
        } else {
          let _temp_array: any = [];
          _temp_array.push(props.customerMsg);
          _temp_array.push(agentBody);
          props.setCustomerMessages(_temp_array, true);
        }
        clearAfterSend()
      }
    }).finally(() => {
      setLoader(false);
    })
  }


  const sendFacebook = () => {
    try {
      if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() && attachFile.length === 0)
        return
      setLoader(true)
      if (attachFile.length > 0) {
        let docx = ''
        if (fileType?.split('/')[1] === 'pdf') {
          docx = "file"
        } else if (mp3Formats.includes(fileType?.split('/')?.[1])) {
          docx = "audio"
        } else if (videoFormat.includes(fileType?.split('/')?.[1])) {
          docx = "video"
        } else if (excelFormats.includes(fileType)) {
          docx = "file"
        } else if (wordFormats.includes(fileType)) {
          docx = "file"
        } else {
          docx = 'image'
        }
        const body = {
          "domainId": currentSession?.domainId,
          "customerId": currentSession?.customerFacebookId.toString(),
          "pageId": currentSession?.agentFacebookId.toString(),
          "mediaUrl": uploadFile,
          "mediaType": docx
        }
        axios.post(`${config().FACEBOOK_URL}/sendMedia`, body, {})
          .then((response: any) => {
            if (response?.data?.status === "Success") {
              facebookToDatabase()
            } else {
              setLoader(false)
            }
          })
          .catch((error: any) => {
            console.log(error)
            setLoader(false)
            setUploadFile(null)
            setFilename(null)
            setFileType(null)
          })
      } else {
        let temp = textMessage?.trim() || '';
        if (temp?.includes("<ul>") && temp?.includes("</ul>")) {
          temp = temp.replace(/<ul>/g, "\n").replace(/<\/ul>/g, "");
          temp = temp.replace(/<li>/g, "• ").replace(/<\/li>/g, "\n");
        } else {
          let counter = 1;
          temp = temp.replace(/<p>/g, "\n");
          temp = temp.replace("<strong>", "*").replace("</strong>", "*");
          temp = temp.replace(/<em>/g, "_").replace(/<\/em>/g, "_");
          temp = temp.replace(/<s>/g, "~").replace(/<\/s>/g, "~");
          temp = temp.replace(/<ol>/g, "\n").replace(/<\/ol>/g, "");
          temp = temp.replace(/<li>/g, () => `${counter++}. `).replace(/<\/li>/g, "\n");
        }
        temp = temp.replace(/<\/div>\s*<div>/g, '\n');
        temp = temp.replace(/<div>/g, '').replace(/<\/div>/g, '\n');
        const textData = temp.replace(/<[^>]+>/g, '').trim()?.replace(/&nbsp;/g, '');
        const body = {
          "domainId": currentSession?.domainId,
          "customerId": currentSession?.customerFacebookId.toString(),
          "pageId": currentSession?.agentFacebookId.toString(),
          "type": "text",
          "message": textData
        }
        axios
          .post(`${config().FACEBOOK_URL}/send`, body, {
          })
          .then((response: any) => {
            console.log("response", response)
            if (response?.data?.status === "Success") {
              facebookToDatabase()
            } else {
              setLoader(false)
            }
          }).catch((error: any) => {
            console.log(error)
            setLoader(false)
          })
      }
    } catch (error) {
      console.log(error)
      setLoader(false)
    }
    resetActiveButtons();
  }



  const facebookToDatabase = () => {
    if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() && attachFile.length === 0)
      return
    setLoader(true);
    let attachement: any = []
    if (attachFile.length > 0 && uploadFile !== '') {
      for (let data of attachFile) {
        attachement.push({
          filename: data?.filename,
          path: data?.path,
          href: data?.url,
          type: data?.mimetype,
          ...data
        })
      }
    }

    let body = {
      sessionId: currentSession.sessionId,
      FacebookHistoryId: currentSession.FacebookHistoryId,
      customerId: currentSession.customerFacebookId,
      pageId: currentSession.agentFacebookId,
      text: textMessage?.trim(),
      attachments: attachement,
      type: "update"
    }
    let agentBody = {
      agentText: {
        message: {
          customerId: currentSession.agentFacebookId,
          pageId: currentSession.customerFacebookId,
          sendAt: Date.now(),
          message: textMessage?.trim(),
          attachments: attachement,
        }
      }
    }
    SocialmediaServices.post(body, `/facebook_out`).then((response: any) => {
      if (response && response.data.statusCode === 200) {
        if (Array.isArray(props.customerMsg) && props.customerMsg.length) {
          props.setCustomerMessages(agentBody);
        } else {
          let _temp_array: any = [];
          _temp_array.push(props.customerMsg);
          _temp_array.push(agentBody);
          props.setCustomerMessages(_temp_array, true);
        }
        // getCurrentSessionData()
        clearAfterSend()
      }
    }).finally(() => {
      setLoader(false);
    })
  }
  const sendInstagram = () => {
    try {
      if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() && attachFile.length === 0)
        return
      setLoader(true);
      if (attachFile.length > 0) {
        let docx = ''
        if (mp3Formats.includes(fileType?.split('/')?.[1])) {
          docx = "Audio"
        } else if (videoFormat.includes(fileType?.split('/')?.[1])) {
          docx = "Video"
        } else {
          docx = 'Image'
        }
        const body = {
          "domainId": currentSession?.domainId,
          "customerId": currentSession?.customerInstagramId.toString(),
          "pageId": currentSession?.agentInstagramId.toString(),
          "mediaUrl": uploadFile,
          "mediaType": docx
        }
        axios.post(`${config().INSTAGRAM_URL}/sendMedia`, body, {})
          .then((response: any) => {
            if (response?.data?.status === "Success") {
              instagramToDatabase()
            } else {
              setLoader(false)
            }
          })
          .catch((error: any) => {
            console.log(error)
            setLoader(false)
            setUploadFile(null)
            setFilename(null)
            setFileType(null)
          })
      } else {
        let temp = textMessage?.trim() || '';
        if (temp?.includes("<ul>") && temp?.includes("</ul>")) {
          temp = temp.replace(/<ul>/g, "\n").replace(/<\/ul>/g, "");
          temp = temp.replace(/<li>/g, "• ").replace(/<\/li>/g, "\n");
        } else {
          let counter = 1;
          temp = temp.replace(/<p>/g, "\n");
          temp = temp.replace("<strong>", "*").replace("</strong>", "*");
          temp = temp.replace(/<em>/g, "_").replace(/<\/em>/g, "_");
          temp = temp.replace(/<s>/g, "~").replace(/<\/s>/g, "~");
          temp = temp.replace(/<ol>/g, "\n").replace(/<\/ol>/g, "");
          temp = temp.replace(/<li>/g, () => `${counter++}. `).replace(/<\/li>/g, "\n");
        }
        temp = temp.replace(/<\/div>\s*<div>/g, '\n');
        temp = temp.replace(/<div>/g, '').replace(/<\/div>/g, '\n');
        const textData = temp.replace(/<[^>]+>/g, '').trim()?.replace(/&nbsp;/g, '');
        const body = {
          "domainId": currentSession?.domainId,
          "customerId": currentSession?.customerInstagramId.toString(),
          "pageId": currentSession?.agentInstagramId.toString(),
          "type": "text",
          "message": textData
        }
        axios
          .post(`${config().INSTAGRAM_URL}/send`, body, {
          })
          .then((response: any) => {
            if (response?.data?.status === "Success") {
              instagramToDatabase()
            } else {
              setLoader(false)
            }
          }).catch((error: any) => {
            console.log(error)
            setLoader(false)
          })
      }
    } catch (error) {
      console.log(error)
      setLoader(false)
    }
    resetActiveButtons();
  }

  const instagramToDatabase = () => {
    if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() && attachFile.length === 0)
      return
    setLoader(true);
    let attachement: any = []
    if (attachFile.length > 0 && uploadFile !== '') {
      for (let data of attachFile) {
        attachement.push({
          filename: data?.filename,
          path: data?.path,
          href: data?.url,
          type: data?.mimetype,
          ...data
        })
      }
    }

    let body = {
      sessionId: currentSession.sessionId,
      InstagramHistoryId: currentSession.InstagramHistoryId,
      customerId: currentSession.customerInstagramId,
      pageId: currentSession.agentInstagramId,
      text: textMessage?.trim(),
      attachments: attachement,
      type: "update"
    }
    let agentBody = {
      agentText: {
        message: {
          customerId: currentSession.agentInstagramId,
          pageId: currentSession.customerInstagramId,
          sendAt: Date.now(),
          message: textMessage?.trim(),
          attachments: attachement,
        }
      }
    }
    SocialmediaServices.post(body, `/instagram_out`).then((response: any) => {
      if (response && response.data.statusCode === 200) {
        if (Array.isArray(props.customerMsg) && props.customerMsg.length) {
          props.setCustomerMessages(agentBody);
        } else {
          let _temp_array: any = [];
          _temp_array.push(props.customerMsg);
          _temp_array.push(agentBody);
          props.setCustomerMessages(_temp_array, true);
        }
        // getCurrentSessionData() 
        clearAfterSend()
      }
    }).finally(() => {
      setLoader(false);
    })
  }

  const sendSms = () => {
    try {
      if (!textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim())
        return
      setLoader(true)
      const body = {
        "destination": currentSession.customerNumber.toString(),
        "source": currentSession.calledNumber.toString(),
        "content": textMessage?.trim()?.replace(/<div>/g, '')?.replace(/<\/div>|<br>/g, '\n')?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim(),
        "domainId": loginUserCcaasDetail?.domainId
      }
      axios
        .post(`${config().SMS_DID}/smsOut`, body, {
          headers: {
            Authorization: accessToken,
          },
        })
        .then((response: any) => {
          if (response?.data?.status === 'Success') {
            smsDataToDatabase()
          } else {
            setLoader(false)
          }
        }).catch((error: any) => {
          console.log(error)
          setLoader(false)
        })

    } catch (error) {
      console.log(error)
      setLoader(false)
    }
    resetActiveButtons();
  }

  const smsDataToDatabase = () => {
    try {
      setLoader(true)
      let agentBody = {
        agentText: {
          message: {
            from: currentSession.calledNumber,
            to: currentSession.customerNumber,
            sendAt: Date.now(),
            message: textMessage?.trim(),
            messageId: uuidv4(),
          }
        }
      }
      const body = {
        sessionId: currentSession.sessionId,
        from: currentSession.calledNumber,
        to: currentSession.customerNumber,
        text: textMessage?.trim()
      }
      SmsServices.post(body, `/ccaas_sms_out`).then((response: any) => {
        if (response && response.data.statusCode === 200) {
          if (Array.isArray(props.customerMsg) && props.customerMsg.length) {
            props.setCustomerMessages(agentBody);
          } else {
            let _temp_array: any = [];
            _temp_array.push(props.customerMsg);
            _temp_array.push(agentBody);
            props.setCustomerMessages(_temp_array, true);
          }
          getCurrentSessionData()
          clearAfterSend()
          props.onSuccessMailSend()
        }
      }).finally(() => {
        setLoader(false);
      })
    } catch (error) {
      setLoader(false);
      console.log(error)
    }
  }



  const getCurrentSessionData = () => {
    let contact = ''
    if (currentSession.channelType === 'Email')
      contact = currentSession?.FromEmail
    else if (currentSession.channelType === 'Sms')
      contact = currentSession?.customerNumber
    else if (currentSession.channelType === 'Whatsapp')
      contact = currentSession?.customerNumber
    else if (currentSession.channelType === 'Facebook')
      contact = currentSession?.customerFacebookId
    else if (currentSession.channelType === 'Instagram')
      contact = currentSession?.customerInstagramId
    dispatch(getNecessaryDetailswithsession({ contact, sessionId: currentSession?.channelType === 'Chat' ? currentSession?.ChatHistoryId : currentSession?.sessionId.trim(), channelType: currentSession?.channelType }))
      .unwrap()
      .then((res: any) => {
        if (res.sessionDetail?.data.statusCode === 200) {
          let chatSessionData: any = res?.sessionDetail?.data?.getEmailListRes[0];
          chatSessionData.Number = currentSession?.customerNumber;
          chatSessionData.showState = true;
          chatSessionData.queueName = ''
          chatSessionData.ChatHistoryId = ''
          chatSessionData.sessionOnGoingTime = currentSession.sessionOnGoingTime
          if (res.contact?.data.statusCode === 200) {
            chatSessionData.calledPersonDetails = res.contact?.data?.getContactNumberRes[0] || res.contact?.data?.getContactDetailsRes?.[0];
          } else {
            chatSessionData.calledPersonDetails = {};
          }
          dispatch(ChatActions.chatSessionList(chatSessionData));
          dispatch(ChatActions.currentChatSession({
            ...currentSession,
            ...chatSessionData,
          }));
        }
      }).catch((error: any) => {
        console.log(error)
      })
  };

  const clearAfterSendCallEmail = () => {

    dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "" }));
    setEditorState(EditorState.createEmpty());
    setFileSrc("");
    setFileType('');
    setUploadFile("");
    setFilename("");
    setTextQuil("");
    setAttachmentFile([])
    setSubject("")
  }
  const clearAfterSend = () => {

    dispatch(ChatActions.updateTypeOfMessage({ typeOfMessage: "" }));
    setEditorState(EditorState.createEmpty());
    setFileSrc("");
    setFileType('');
    setUploadFile("");
    setFilename("");
    setTextQuil("");
    setAttachmentFile([])
    const textClr: any = document.getElementById('textedited');
    if (textClr !== '') {
      textClr.textContent = "";
      textClr.innerHTML = "";
      textClr.focus();
      setMessageInfo('');
    }
  }
  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || (window as any).clipboardData;
    const pastedHtml = clipboardData.getData('text/html');
    const pastedText = clipboardData.getData('text/plain');

    const content = pastedHtml || `<p>${pastedText}</p>`;
    document.execCommand('insertHTML', false, content);
  };

  const onUpdateMessage = (event: any) => {
    const textClr: any = document.getElementById('textedited');
    setMessageInfo(textClr?.innerHTML);
    const payload = {
      from: agentId,
      sessionId: currentSession?.sessionId,
      to: currentSession?.sessionId,
      typingStatus: true,
      sender: { uuid: LoginUserDetails?.uuid, Name: LoginUserDetails?.profileName, Email: LoginUserDetails?.username },
      ChatHistoryId: parseInt(currentSession?.ChatHistoryId),
      ChatDurationHistoryId: parseInt(currentSession?.ChatDurationHistoryId),
      sendAt: Date.now(),
    }
    callChatService.agentTypingStatus(payload);

  }
  const onUpdateMessageCall = (event: any, type: any) => {
    const textClr: any = document.getElementById('textedited');
    const cleanText = textClr?.innerHTML
      ?.replace(/<div>/g, '')
      .replace(/<\/div>|<br>/g, '\n')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ');

    setMessageInfo(type === 'sms' ? cleanText : textClr?.innerHTML);
  };

  const changeFile = async (event: any) => {
    setUploadFile("");
    setFilename("");
    const formData = new FormData();
    const filevalue = []
    for (let file of event.target.files) {
      formData.append("doc", file);
      filevalue.push({
        uid: file?.uid,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        name: file?.name,
        size: file?.size,
        type: file?.type,
        webkitRelativePath: file?.webkitRelativePath,
        fileType: file?.type,
        message: file,
      })
    }

    const maxFileSizeInBytes = 5 * 1024 * 1024; // 5 MB
    // setFileType((file :any)=> [...file,...filevalue]);

    setFileType(filevalue);
    await EmailServices.post(formData, `/file_upload`).then((res: any) => {
      if (res.data.statusCode === 200) {
        setAttachmentFile((prevState: any) => [...prevState, ...res.data?.fileList])
        setUploadFile(res.data?.fileList[0].url);
        setFilename(event.target.files[0].name);
      }
    })
  };
  const boldTextContent = (type: any) => {
    var edit: any = document.getElementById("textedited");
    edit.focus();
    document.execCommand(type, false, '');
    var str = edit.innerHTML.replace(/<\/?span[^>]*>/g, "");
    if (type === "BOLD") {
      let bbCas = activeButton.bold ? "type" : type
      setActiveButton({ ...activeButton, bold: !activeButton.bold, activeBtn: bbCas })
    } else if (type === "ITALIC") {
      let bbCas = activeButton.italic ? "type" : type
      setActiveButton({ ...activeButton, italic: !activeButton.italic, activeBtn: bbCas })
    } else if (type === "STRIKETHROUGH") {
      let bbCas = activeButton.strikethrough ? "type" : type
      setActiveButton({ ...activeButton, strikethrough: !activeButton.strikethrough, activeBtn: bbCas })
    } else if (type === "LINK") {
      let bbCas = activeButton.bold ? "type" : type
      setActiveButton({ ...activeButton, link: !activeButton.link, activeBtn: bbCas })
    } else if (type === "insertUnorderedList") {
      let bbCas = activeButton.unordered_list ? "type" : type
      setActiveButton({ ...activeButton, unordered_list: !activeButton.unordered_list, activeBtn: bbCas })
    } else if (type === "insertOrderedList") {
      let bbCas = activeButton.ordered_list ? "type" : type
      setActiveButton({ ...activeButton, ordered_list: !activeButton.ordered_list, activeBtn: bbCas })
    }
    setMessageInfo(str);

  }



  const handleChangeCC = (value: any) => {
    setCcEmail(value)
  };
  const handleChangeBCC = (value: any) => {
    setBccEmail(value)
  };

  const changeSubject = async (e: any) => {
    setSubject(e.target.value);
    setError(false)

  };



  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <span className="drpdwnList"><span className="icon__DashboardGreen24" /> rubyfrwh@worktual.com </span>
      ),
    },
    {
      key: '2',
      label: (
        <span className="drpdwnList"><span className="icon__DashboardGreen24" /> rubyfrwh@worktual.com </span>
      ),
    },
    {
      key: '3',
      label: (
        <span className="drpdwnList"><span className="icon__DashboardGreen24" /> rubyfrwh@worktual.com </span>
      ),
    },
  ];



  const sendOutBoundSMSForCall = () => {
    try {
      const sms_content = textMessage?.replace(/<div>/g, '').replace(/<\/div>|<br>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')
      const num = props.sms_email?.[1] || ''
      if (sms_content?.trim() === '' || num === '') {
        return
      }
      setLoader(true)
      const body = {
        sessionId: currentSession.sessionId,
        from: currentSession.companySMSNumber?.toString(),
        to: num,
        text: sms_content
      }
      SmsServices.post(body, `/send_sms_outbound`).then((response: any) => {
        if (response && response.data.statusCode === 200) {
          console.log('sms send')
          props.cancelCalllive()
          const transferDataDetails = {

            id: uuidv4(),
            from: `${loginUserCcaasDetail?.domainId}_${loginUserCcaasDetail?.ext}`,
            domainId: loginUserCcaasDetail?.domainId,
            ext: loginUserCcaasDetail?.ext,
            to: currentSession?.sessionId,
            sessionId: currentSession?.sessionId,
            message: { "agentText": { "message": { "to": num, "from": currentSession.companySMSNumber?.toString(), "sendAt": Math.floor(Date.now() / 1000), "message": sms_content, "messageId": uuidv4() } } },
            toNumber: num,
            Smstext: sms_content,
            sender: {
              uuid: loginUserCcaasDetail?.UserID,
              Name: loginUserCcaasDetail?.UserName,
              Email: loginUserCcaasDetail?.emailId
            },
            isBot: false,
            isCustomer: false,
            isTransfer: false,
            isEmail: false,
            isSms: true,
            messageType: 'Text',
            sendAt: Math.floor(Date.now() / 1000), // Convert to Unix timestamp in seconds
            chatIconLogo: '',
            timestamp: Math.floor(Date.now() / 1000) // Convert to Unix timestamp in seconds
          };
          const smsData = response?.data?.smsSendResponse

          const smsSendDetails = {
            SMSHistoryId: smsData?.SMSHistoryId,
            dispositionId: null,
            summary: "",
            isSessionClosed: 1,
            AfterEmailWorkTime: 0,
            dispositionUpdatedBy: loginUserCcaasDetail?.UserID,
            duration: 0,
            responseChannelType: currentSession?.channeltype,
            responseHistoryId: currentSession?.CallHistoryId ?? null,
            coid: currentSession?.calledPersonDetails?.coid ?? null,
          }
          try {
            SmsServices.put(smsSendDetails, `/update_replyvia_disposition_sms`).then((response: any) => {
              if (response && response.data.statusCode === 200) {


              }

            })
          } catch (error) {
            console.log(error)
          }

          dispatch(ChatActions.agentWorkSpaceTansferHistory(transferDataDetails))
          callChatService.callViaSmsEmail(transferDataDetails)
          console.log(transferDataDetails, "transferDataDetails>>>>>>>>>>>")
        }
      }).finally(() => {
        setLoader(false);
      })
    } catch (e: any) {
      console.log(e)
      setLoader(false);
    }
  }
  const handleCloseWindow = () => {

    props.setSms_email(null);
    clearAfterSendCallEmail()

  };
  const sendOutBoundSMS = () => {
    try {
      const sms_content = textMessage?.replace(/<div>/g, '').replace(/<\/div>|<br>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')
      const num = props.sms_email?.[1] || ''
      if (sms_content?.trim() === '' || num === '') {
        return
      }
      setLoader(true)
      const body = {
        sessionId: currentSession.sessionId,
        from: currentSession.companySMSNumber?.toString(),
        to: num,
        text: sms_content
      }
      SmsServices.post(body, `/send_sms_outbound`).then((response: any) => {
        if (response && response.data.statusCode === 200) {
          console.log('sms send')
          props.cancelCall()
          const smsData = response?.data?.smsSendResponse
          const historyId = (currentSession?.channelType == "Whatsapp") ?
            (currentSession?.WhatsappHistoryId || null) :
            (currentSession?.channelType == "Chat") ?
              (currentSession?.ChatHistoryId || null) :
              (currentSession?.channelType == "Facebook") ?
                (currentSession?.FacebookHistoryId || null) :
                (currentSession?.channelType == "Instagram") ?
                  (currentSession?.InstagramHistoryId || null) :
                  (currentSession?.channelType == "Voicemail") ?
                    (currentSession?.CallHistoryId || null) :
                    null;
          const smsSendDetails = {
            SMSHistoryId: smsData?.SMSHistoryId,
            dispositionId: null,
            summary: "",
            isSessionClosed: 1,
            AfterEmailWorkTime: 0,
            dispositionUpdatedBy: loginUserCcaasDetail?.UserID,
            duration: 0,
            responseChannelType: currentSession?.channelType,
            responseHistoryId: historyId ?? null,
            coid: currentSession?.calledPersonDetails?.coid ?? null,
          }
          try {
            SmsServices.put(smsSendDetails, `/update_replyvia_disposition_sms`).then((response: any) => {
              if (response && response.data.statusCode === 200) {


              }

            })
          } catch (error) {
            console.log(error)
          }

          {
            currentSession?.channelType === "Voicemail" &&
              sessionStorage.setItem("callback", JSON.stringify(currentSession?.sessionId));
            sessionStorage.setItem("voicemailCB", "1");
            sessionStorage.setItem('callBackHistoryId', JSON.stringify(currentSession?.sessionId))
          }
        }
      }).finally(() => {
        setLoader(false);
      })
    } catch (e: any) {
      console.log(e)
      setLoader(false);
    }
  }
  const sendOutBoundEmailForCaLL = async (e: any) => {
    try {
      // textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() === ''  chabged due to  bold tag removed in 
      if (textMessage?.trim() === '' || subject === '' || currentSession?.companyEmailAddress === '' || toMailList?.length === 0) {
        setError(true)
        return
      }
      setLoader(true)

      let attachement: any = []
      if (attachFile.length > 0 && uploadFile !== '') {
        for (let data of attachFile) {
          attachement.push({
            filename: data?.filename,
            path: data?.path,
            href: data?.url,
            type: data?.mimetype,
            ...data
          })
        }
      }
      let body = {
        id: uuidv4(),
        fileName: filename,
        filePath: uploadFile,
        sessionId: currentSession?.sessionId,
        emailHistoryId: currentSession?.EmailHistoryId,
        subject: subject,
        to: toMailList?.join(','),
        from: currentSession?.companyEmailAddress,
        text: textMessage?.trim(),
        cc: ccEmail?.join(','),
        bcc: bccEmail?.join(','),
        attachments: attachement,
        isBot: 0
      }

      EmailServices.post(body, `/send_email_outbound`).then((response: any) => {
        if (response && response.data.statusCode === 200) {
          setError(false)

          const emailData = response?.data?.sendOutboundResponse
          console.log('Email send')
          props.cancelCalllive()

          const transferDataDetails = {

            id: uuidv4(),
            from: `${loginUserCcaasDetail?.domainId}_${loginUserCcaasDetail?.ext}`,
            domainId: loginUserCcaasDetail?.domainId,
            ext: loginUserCcaasDetail?.ext,
            to: currentSession?.sessionId,
            sessionId: currentSession?.sessionId,
            message: JSON.parse(response?.data?.sendOutboundResponse?.Message),
            fileName: filename,
            filePath: uploadFile,
            subject: subject,
            sendTo: toMailList?.join(','),
            sendText: textMessage?.trim(),
            sendCc: ccEmail?.join(','),
            sendBcc: bccEmail?.join(','),
            attachments: attachement,
            sender: {
              uuid: loginUserCcaasDetail?.UserID,
              Name: loginUserCcaasDetail?.UserName,
              Email: loginUserCcaasDetail?.emailId
            },
            isBot: false,
            isCustomer: false,
            isTransfer: false,
            isSms: false,
            isEmail: true,
            messageType: "Text",
            sendAt: Math.floor(Date.now() / 1000),
            chatIconLogo: '',
            timestamp: Math.floor(Date.now() / 1000)
          };
          const emailSendDetails = {
            EmailHistoryId: emailData?.EmailHistoryId,
            dispositionId: null,
            summary: "",
            isSessionClosed: 1,
            AfterEmailWorkTime: 0,
            dispositionUpdatedBy: loginUserCcaasDetail?.UserID,
            duration: 0,
            responseChannelType: currentSession?.channeltype,
            responseHistoryId: currentSession?.CallHistoryId ?? null,
            coid: currentSession?.calledPersonDetails?.coid ?? null
          }
          try {
            EmailServices.put(emailSendDetails, `/update_replyvia_disposition_email`).then((response: any) => {
              if (response && response.data.statusCode === 200) {


              }

            })
          } catch (error) {
            console.log(error)
          }

          dispatch(ChatActions.agentWorkSpaceTansferHistory(transferDataDetails))
          callChatService.callViaSmsEmail(transferDataDetails)
          clearAfterSendCallEmail()
        }
      }).finally(() => {
        setLoader(false);
      })
    } catch (error) {
      console.log(error)
      setLoader(false);
    }
  };



  const sendOutBoundEMAIL = async (e: any) => {
    try {
      if (textMessage?.trim()?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, '')?.trim() === '' || subject === '' || currentSession?.companyEmailAddress === '' || toMailList?.length === 0) {
        setError(true)
        return
      }
      setLoader(true)

      let attachement: any = []
      if (attachFile.length > 0 && uploadFile !== '') {
        for (let data of attachFile) {
          attachement.push({
            filename: data?.filename,
            path: data?.path,
            href: data?.url,
            type: data?.mimetype,
            ...data
          })
        }
      }
      let body = {
        id: uuidv4(),
        fileName: filename,
        filePath: uploadFile,
        sessionId: currentSession?.sessionId,
        emailHistoryId: currentSession?.EmailHistoryId,
        subject: subject,
        to: toMailList?.join(','),
        from: currentSession?.companyEmailAddress ?? currentSession?.ToEmail,
        text: textMessage?.trim(),
        cc: ccEmail?.join(','),
        bcc: bccEmail?.join(','),
        attachments: attachement,
        isBot: 0
      }
      EmailServices.post(body, `/send_email_outbound`).then((response: any) => {
        if (response && response.data.statusCode === 200) {
          const emailData = response?.data?.sendOutboundResponse

          console.log('Email send')
          if (currentSession?.channelType == "Email") {
            props.onSuccessMailSend()

          } else {
            props.cancelCall()

          }
          const historyId = (currentSession?.channelType == "Whatsapp") ?
            (currentSession?.WhatsappHistoryId || null) :
            (currentSession?.channelType == "Chat") ?
              (currentSession?.ChatHistoryId || null) :
              (currentSession?.channelType == "Email") ?
                (currentSession?.EmailHistoryId || null) :
                (currentSession?.channelType == "Facebook") ?
                  (currentSession?.FacebookHistoryId || null) :
                  (currentSession?.channelType == "Instagram") ?
                    (currentSession?.InstagramHistoryId || null) :
                    (currentSession?.channelType == "Voicemail") ?
                      (currentSession?.CallHistoryId || null) :
                      null;
          const emailSendDetails = {
            EmailHistoryId: emailData?.EmailHistoryId,
            dispositionId: null,
            summary: "",
            isSessionClosed: 1,
            AfterEmailWorkTime: 0,
            dispositionUpdatedBy: loginUserCcaasDetail?.UserID,
            duration: 0,
            responseChannelType: currentSession?.channelType,
            responseHistoryId: historyId ?? null,
            coid: currentSession?.calledPersonDetails?.coid ?? null,
          }
          if (currentSession?.channelType !== "Email") {
            try {
              EmailServices.put(emailSendDetails, `/update_replyvia_disposition_email`).then((response: any) => {
                if (response && response.data.statusCode === 200) {


                }

              })
            } catch (error) {
              console.log(error)
            }
          }

          {
            currentSession?.channelType === "Voicemail" &&
              sessionStorage.setItem("callback", JSON.stringify(currentSession?.sessionId));
            sessionStorage.setItem("voicemailCB", "1");
            sessionStorage.setItem('callBackHistoryId', JSON.stringify(currentSession?.sessionId))
          }
        }
      }).finally(() => {
        setLoader(false);
      })
    } catch (error) {
      console.log(error)
      setLoader(false);
    }
    resetActiveButtons();
  };
  const planId: any = GetItemFromStorage(LocalStorage.PLAN_ID);
  const channelTypesList = ['Sms', 'Chat', "Whatsapp", "Email", 'Facebook', 'Instagram', "Whatsapp", "Email", 'Voicemail']

  const [openTrasriptModel, setOpenTransriptModel] = useState(false)
  const trascriptUpgrade = () => {
    setOpenTransriptModel(true)
  }

  const sendDNDError = () => {
    notification.error({
      message: `Customer has invoked DND — No Calls, SMS, or Emails permitted.`,
      placement: "topRight",
      className: "toastNotification error",
      icon: <span className="icon__Error24" />,
      closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
      </svg>,
      duration: 3,
      top: 70,
    });
  }
  // { console.log("currentSession email>>>>>>>>>>", (props.sms_email?.[0], currentSession.channelType,"messsage", currentSession.Message)) } 

  const resetActiveButtons = () => {
    setActiveButton({
      bold: false,
      italic: false,
      strikethrough: false,
      link: false,
      unordered_list: false,
      ordered_list: false,
      activeBtn: ''
    });
  }

  return (
    <>
      {openTrasriptModel && <Internalupgrade onOk={() => setOpenTransriptModel(false)} />}
      {
        (
           checkCurrentSessionChannel(currentSession, ['Call']) ||
          (currentSession?.CallHistoryId && currentSession?.IsInBound)
        ) &&
          !hassAccess('callTranscript')
          ? <UpgradeTranscription onOk={trascriptUpgrade} />
          : <>
            {currentSession?.CallHistoryId == null || channelTypesList.includes(currentSession.channelType) ?
              <div className={`neweditor neweditoremail ${currentSession?.supervisorStatus === 'whisper' && (loginUserCcaasDetail?.roleid == '5' || loginUserCcaasDetail?.roleid == '3')
                  ? styles.editwhisperheight : ''}`} id="neweditId">
                {isTransfer && (
                  <div className={styles.calltransfer}>
                    Chat Transfer to <span>Albert Flores</span>
                  </div>
                )}
                {currentSession?.supervisorStatus === 'whisper' && (loginUserCcaasDetail?.roleid == '5' || loginUserCcaasDetail?.roleid == '3')
                  ? <div className={styles.whispertool}>
                    <p><svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                      <path d="M6.01751 2.3835C5.99471 1.81577 5.94624 1.45643 5.85571 1.16997C5.73884 0.808632 5.55164 0.554099 5.28184 0.390699C4.81211 0.108166 4.25711 0.0996988 3.76004 0.367899C3.21678 0.658899 2.59791 1.24223 1.63371 2.1687L1.15424 2.62897C0.492444 3.2579 0.127844 3.60423 0.0569108 4.1179C0.0383774 4.24683 0.0383773 4.38417 0.0565773 4.5111C0.127844 5.02803 0.495044 5.38023 1.16171 6.02083L1.67178 6.5111C2.62651 7.42323 3.25704 8.02543 3.80851 8.29363C4.19524 8.48697 4.64084 8.51043 5.03151 8.3607C5.39151 8.22137 5.66598 7.9473 5.80398 7.5905C5.93611 7.25063 5.98884 6.8203 6.01164 6.23503C7.47324 6.3177 8.32838 6.6081 8.68611 7.13803C9.06304 7.69663 8.98784 8.65883 8.45598 10.0794C8.37004 10.3086 8.42698 10.567 8.60118 10.7376C8.71804 10.8522 8.87364 10.9134 9.03284 10.9134C9.11098 10.9134 9.18978 10.8984 9.26524 10.8685C10.5657 10.3431 11.958 8.5801 11.958 6.7923C11.958 3.14777 8.87978 2.47597 6.01751 2.3835Z" fill="#575CFF" />
                    </svg> Chat Whisper</p>
                  </div>
                  : ''}

                <div className={`neweditorinput neweditorinputweb responswebchat scroller ${mailState.bccState ? "addfromtohight" : ""}`} >
                  {(currentSession.channelType === "Email" || (props.sms_email?.[0] === 'email' && currentSession.channelType === 'Chat' || (currentSession.channelType === 'Whatsapp' && currentSession.callBack == 1) || (currentSession.channelType === 'Instagram' && currentSession.callBack == 1) || (currentSession.channelType === 'Facebook' && currentSession.callBack == 1) || (props.sms_email?.[0] === 'email' && currentSession.channelType === 'Voicemail'))) &&

                    <div className="chatinputfrom">
                      {(currentSession && currentSession.Message && currentSession.channelType !== 'Whatsapp' && currentSession.channelType !== 'Facebook' && currentSession.channelType !== 'Instagram') &&
                        <div className="editorcc">
                          <label>To</label>
                          <div className="editorccselect">
                            <Select
                              open={false}
                              mode="tags"
                              style={{ width: '100%' }}
                              onChange={onChangeToMailListFun}
                              value={toMailList}
                              options={options}
                              popupClassName="innerdrophidden"
                              className="antSelect nbdrSel"
                            />
                            <div className="ccadd">
                              <p onClick={() => setMailState({ ...mailState, ccState: !mailState.ccState })}>Cc</p>
                              <p onClick={() => setMailState({ ...mailState, bccState: !mailState.bccState })}>Bcc</p>
                            </div>
                          </div>
                          {/* {mailState.ccState && <div className="cctextsecmain"><label onClick={() => mailState.ccState = !mailState.ccState}>Cc</label><label onClick={() => mailState.bccState = !mailState.bccState}>Bcc</label></div>} */}
                        </div>
                      }
                      {(currentSession.channelType == 'Voicemail' && currentSession.channelType !== 'Whatsapp' && currentSession.channelType !== 'Facebook' && currentSession.channelType !== 'Instagram') &&
                        <div className="editorcc">
                          <label>To</label>
                          <div className="editorccselect">
                            <Select
                              open={false}
                              mode="tags"
                              style={{ width: '100%' }}
                              onChange={onChangeToMailListFun}
                              value={toMailList}
                              options={options}
                              popupClassName="innerdrophidden"
                              className="antSelect nbdrSel"
                            />
                            <div className="ccadd">
                              <p onClick={() => setMailState({ ...mailState, ccState: !mailState.ccState })}>Cc</p>
                              <p onClick={() => setMailState({ ...mailState, bccState: !mailState.bccState })}>Bcc</p>
                            </div>
                          </div>
                          {/* {mailState.ccState && <div className="cctextsecmain"><label onClick={() => mailState.ccState = !mailState.ccState}>Cc</label><label onClick={() => mailState.bccState = !mailState.bccState}>Bcc</label></div>} */}
                        </div>
                      }
                      {mailState.ccState && currentSession.channelType !== 'Facebook' && currentSession.channelType !== 'Instagram' &&

                        <div className="editorcc">
                          <label>Cc</label>
                          <div className="editorccselect">
                            <Select
                              mode="tags"
                              open={false}
                              style={{ width: '100%' }}
                              onChange={handleChangeCC}
                              options={options}
                              value={ccEmail}
                              className="antSelect"
                              popupClassName="innerdrophidden"
                            />
                          </div>
                        </div>
                      }
                      {mailState.bccState && currentSession.channelType !== 'Facebook' && currentSession.channelType !== 'Instagram' &&

                        <div className="editorcc">
                          <label>Bcc</label>
                          <div className="editorccselect">
                            <Select
                              mode="tags"
                              open={false}
                              style={{ width: '100%' }}
                              onChange={handleChangeBCC}
                              options={options}
                              value={bccEmail}
                              className="antSelect"
                              popupClassName="innerdrophidden"
                            />
                          </div>
                        </div>
                      }
                      {(props.sms_email?.[0] === 'email' && ((currentSession.channelType === 'Whatsapp' && currentSession.callBack == 1) || currentSession.channelType === 'Facebook' && currentSession.callBack == 1 || currentSession.channelType === 'Instagram' && currentSession.callBack == 1)) && <>
                        {(currentSession) &&
                          <div className="editorcc">
                            <label>To</label>
                            <div className="editorccselect">
                              <Select
                                open={false}
                                mode="tags"
                                style={{ width: '100%' }}
                                onChange={onChangeToMailListFun}
                                value={toMailList}
                                options={options}
                                popupClassName="innerdrophidden"
                                className="antSelect nbdrSel"
                              />
                              <div className="ccadd">
                                <p onClick={() => setMailState({ ...mailState, ccState: !mailState.ccState })}>Cc</p>
                                <p onClick={() => setMailState({ ...mailState, bccState: !mailState.bccState })}>Bcc</p>
                              </div>
                            </div>
                            {/* {mailState.ccState && <div className="cctextsecmain"><label onClick={() => mailState.ccState = !mailState.ccState}>Cc</label><label onClick={() => mailState.bccState = !mailState.bccState}>Bcc</label></div>} */}
                          </div>}

                        {mailState.ccState &&

                          <div className="editorcc">
                            <label>Cc</label>
                            <div className="editorccselect">
                              <Select
                                mode="tags"
                                open={false}
                                style={{ width: '100%' }}
                                onChange={handleChangeCC}
                                options={options}
                                value={ccEmail}
                                className="antSelect"
                                popupClassName="innerdrophidden"
                              />
                            </div>
                          </div>

                        }

                        {mailState.bccState &&

                          <div className="editorcc">
                            <label>Bcc</label>
                            <div className="editorccselect">
                              <Select
                                mode="tags"
                                open={false}
                                style={{ width: '100%' }}
                                onChange={handleChangeBCC}
                                options={options}
                                value={bccEmail}
                                className="antSelect"
                                popupClassName="innerdrophidden"
                              />
                            </div>
                          </div>
                        }</>
                      }

                      {(props.sms_email?.[0] === 'email' || currentSession.channelType === 'Email') &&
                        <div className="editorcc forsubjects">
                          <label>Subject :</label>
                          <div className="editorccselect">
                            {props.sms_email?.[0] === 'email'
                              ? <input type="text" id="subject" name="subject" value={subject} onChange={changeSubject}></input>
                              : (currentSession.EmailSubject) ? currentSession.EmailSubject : <input type="text" id="subject" name="subject" value={subject} onChange={changeSubject}></input>}
                            {error && subject === '' &&
                              <Tooltip placement="top" title="Subject is Required" overlayClassName="customtooltipsmall">
                                <span className={`icon__Warning20 ${styles.invalidTime}`}></span>
                              </Tooltip>}
                          </div>
                        </div>}
                    </div>}
                  {attachFile?.length > 0 &&
                    attachFile.map((row: any, index: any) => {
                      return (
                        <div className={styles.chateditorfileBottom}>
                          <div className={styles.left}>
                            {imageFormat.indexOf(row?.mimetype) !== -1 ?
                              <img src={row?.url} alt="" /> :
                              excelFormats.indexOf(row?.mimetype) !== -1 ?
                                <img src={Excelicon} alt="" /> :
                                pptFormats.indexOf(row?.mimetype) !== -1 ?
                                  <img src={fileppt} alt="" /> :
                                  wordFormats.indexOf(row?.mimetype) !== -1 ?
                                    <img src={Wordicon} alt="word" /> :
                                    videoFormat.indexOf(row?.mimetype) !== -1 ?
                                      <span className="icon__PlayPrompt20"></span> :
                                      mp3Formats.indexOf(row?.mimetype) !== -1 ?
                                        <span className="icon__WidgetMusic24"></span> :
                                        <img src={Pdficon} alt="word" />
                            }

                          </div>
                          <div className={styles.right}>
                            <p>{row?.filename}</p>
                            <p>{(row?.size / 1024).toFixed(2)} KB</p>
                          </div>
                          <div
                            className={styles.chatmsgclose}
                            onClick={(e: any) => {
                              const data = [...attachFile]
                              data.splice(index, 1)
                              setAttachmentFile([...data])
                            }}
                          ><span className="icon__circleclose16" /></div>
                        </div>
                      )
                    })

                  }
                  {/* <div className={`scroller ${styles.textAreaSec}`} contentEditable="true" id="textedited" onInput={(e: any) => onUpdateMessage(e)} placeholder="Enter Text to send">

          </div> */}
                  <div
                    className={`scroller ${styles.textAreaSec} ${styles.noscroll}`}
                    contentEditable={true}
                    id="textedited"
                    placeholder="Enter Text to send"
                    onInput={onUpdateMessage}
                    onPaste={handlePaste}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div>
                  <div className={`emojitool ${styles.editortool}`}>

                    <div className={`${styles.editortooliconsnew} ${styles.editortooliconsnewtool}`}>
                      <div className={styles.left}>
                        {false && <div className={styles.editorselect}>
                          <Select className={`${styles.editorselectdropdown} antSelect`} placeholder="Reply Via">
                            <Option value="premiumcustomer">Premium</Option>
                            <Option value="vipcustomer">VIP Customer</Option>
                          </Select>
                        </div>}
                        {(currentSession.channelType === 'Chat' &&
                          currentSession.CallBackStatus == 1) || (currentSession.channelType === 'Whatsapp' && currentSession.callBack == 1) || (currentSession.channelType === 'Facebook' && currentSession.callBack == 1) || (currentSession.channelType === 'Instagram' && currentSession.callBack == 1) || currentSession.channelType === 'Voicemail' &&
                          <div className={styles.replydiv}>
                            <Select
                              className={`antSelect ${styles.replayVia}`}
                              placeholder="Reply Via"
                              value={props.sms_email?.[0]?.toUpperCase() || null}
                              popupClassName="antSelectPopover replyselects"

                              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676" />
                              </svg>}
                              onChange={(d: any, record: any) => {
                                if (`${currentSession?.calledPersonDetails?.doNotDisturb}` === '1') {
                                  sendDNDError()
                                } else if (!props.omniChannelPurchased.emailAddress && !props.omniChannelPurchased.smsNumber && !props.omniChannelPurchased?.callNumber) {
                                  props.setSms_email(null)
                                  props.setplanPurchaseModel(true)
                                } else if (props.omniChannelPurchased?.smsNumber && record.name === 'sms') {
                                  sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
                                  sessionStorage.setItem("callbackWhatsapp", currentSession.sessionId);
                                  sessionStorage.setItem("callbackChannelType", currentSession?.channelType);
                                  sessionStorage.setItem('callBackSocialmediaHistoryId', JSON.stringify((currentSession?.channelType == "whatsapp" || currentSession?.channelType === "Whatsapp") ? currentSession?.WhatsappHistoryId : (currentSession?.channelType == "Facebook") ? currentSession?.FacebookHistoryId : currentSession?.InstagramHistoryId))
                                  props.setSms_email(['sms', record.value_])
                                } else if (props.omniChannelPurchased?.callNumber && record.name === 'call' && currentSession.channelType !== 'Whatsapp') {
                                  currentSession?.channelType == 'Chat' ? props.makeCallback(currentSession, record.value_) : currentSession?.channelType == 'Voicemail' ? props.makeCallbackForCall(currentSession, record.value_) : props.makeCallbackWhatsapp(currentSession, record.value_)
                                } else if (props.omniChannelPurchased.emailAddress && record.name === 'email') {
                                  sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
                                  sessionStorage.setItem("callbackWhatsapp", currentSession.sessionId);
                                  sessionStorage.setItem("callbackChannelType", currentSession?.channelType);
                                  sessionStorage.setItem('callBackSocialmediaHistoryId', JSON.stringify((currentSession?.channelType == "whatsapp" || currentSession?.channelType === "Whatsapp") ? currentSession?.WhatsappHistoryId : (currentSession?.channelType == "Facebook") ? currentSession?.FacebookHistoryId : currentSession?.InstagramHistoryId))
                                  props.setSms_email(['email', record.value_])
                                } else {
                                  props.setSms_email(null)
                                  props.setplanPurchaseModel(true)
                                }
                              }}>
                              {props.replayViaOptions?.map((data: any) => <Select.Option key={data.key} name={data.name} value_={data.value} >{data.label}</Select.Option>)}
                            </Select>
                          </div>}
                        {currentSession?.whisperText !== ''
                          ? <>
                            <button ref={emojiButtonRef} >
                              <img src={chatsmilefont} onClick={() => toggleEmojiPicker()} alt="emoji" />
                              <span className="iconopen"></span>
                              {emojiModalVisible && (
                                <div ref={emojiModalRef} className="emojipicker emojipickeralign">
                                  <Picker data={data} onEmojiSelect={selectMessage} onLeave={close} />
                                </div>
                              )}
                            </button>
                            {(currentSession.channelType === "Sms" || currentSession.channelType === "Email"|| currentSession.channelType === "Instagram" || (currentSession.CallBackStatus != 1 && currentSession.callBack != 1 && currentSession.channelType !== "Call")) &&
                              inlineStyleButtons.map((button) => {
                                if ((currentSession.channelType === "Instagram" || currentSession.channelType=== "Facebook") && (button.style === 'BOLD' || button.style === 'ITALIC' || button.style === 'STRIKETHROUGH')) {
                                  return null;
                                }
                                return (
                                  <button
                                    key={button.style}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => boldTextContent(button.style)}
                                    className={`${button.style === activeButton?.activeBtn ? styles.active : ""}`}
                                  >
                                    {button.label}
                                  </button>
                                );
                              })
                            }

                            {/* <button><img src={chatlinkfont} /></button> */}
                            {(currentSession.channelType !== "Sms" && currentSession.CallBackStatus != 1 && currentSession.channelType !== "Call" && !currentSession?.CallHistoryId && currentSession.channelType === "Facebook" || currentSession.channelType === "Instagram" || currentSession.channelType === "Whatsapp" || currentSession.channelType === "Email" || (currentSession.channelType === 'Voicemail' && props.sms_email?.[0] === 'email')) &&
                              <>
                                <div className={styles.fileuploadbtn}>
                                  <button >
                                    <input
                                      ref={fileInputRef}
                                      type="file"
                                      accept={currentSession.channelType === "Instagram" ? "image/*,audio/*,video/*" : `${[...wordFormats, ...pptFormats, ...excelFormats, ...imageFormat, ...mp3Formats_, ...videoFormat, ...pdfFormats].join(',')}`}
                                      onChange={(currentSession.channelType === "Email") ? changeFile : handleFileUpload}
                                      onClick={(event: any) => {
                                        event.currentTarget.value = null;
                                      }}
                                      multiple={true}
                                    />
                                  </button>
                                  <p onClick={handleFileUploadRef}>
                                    <img src={chatattachfont} alt="file" />
                                    {/* <span className={styles.fileName}>{filename}</span> */}
                                  </p>
                                </div>
                              </>}
                          </>
                          : ''}
                      </div>
                      <div className={`${styles.right}`}>
                        {currentSession && currentSession.ChatHistoryId !== '' && currentSession.ChatHistoryId !== undefined && currentSession.ChatHistoryId !== null && currentSession.Istransferred !== 1 && props?.sms_email === null &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={sendMessageChat}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        {currentSession && (currentSession.channelType === 'Sms' || props.sms_email?.[0] === 'sms') &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={props.sms_email?.[0] === 'sms' ? sendOutBoundSMS : sendSms}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        {currentSession && (currentSession.channelType === 'Email' || props.sms_email?.[0] === 'email') &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={(props.sms_email?.[0] === 'email' || !currentSession?.IsInBound) ? sendOutBoundEMAIL : btnSendEmail}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        {currentSession && currentSession.channelType === 'Whatsapp' && currentSession.callBack !== 1 &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={sendWhatsapp}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        {currentSession && currentSession.channelType === 'Facebook' && currentSession.callBack !== 1 &&
                          <label
                            className={`icon__InteractionMail24 `}
                            onClick={sendFacebook}
                          ></label>
                        }
                        {currentSession && currentSession.channelType === 'Instagram' && currentSession.callBack !== 1 &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={sendInstagram}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div> :

              <div className="neweditor neweditoremail" id="neweditId">


                {props.sms_email?.[0] === 'email' && <>
                  <div className={`${styles.rplyviacont} ${styles.replyviacontnew}`}>
                    <div className={styles.replyshareblock}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                          <g clip-path="url(#clip0_5261_66931)">
                            <path d="M6.45772 2.62132C6.44336 1.80299 6.40747 1.20001 6.27826 0.790844C6.18494 0.50371 6.04855 0.302716 5.84756 0.180684C5.45275 -0.0562018 5.00769 -0.0490234 4.6057 0.166327C4.03143 0.474996 3.29924 1.16412 2.20813 2.21216L1.6554 2.74336C0.930384 3.43248 0.564288 3.77704 0.506861 4.19338C0.492505 4.29388 0.492505 4.40156 0.506861 4.50205C0.564288 4.9184 0.923206 5.26296 1.64822 5.95926L2.20095 6.49046C3.32795 7.56721 4.06015 8.27069 4.64877 8.55782C5.2374 8.85214 5.98395 8.65832 6.22801 8.02662C6.39311 7.6031 6.43618 6.95705 6.45054 6.03104C10.1976 6.12436 11.8056 7.12933 10.6786 10.7113C10.5494 11.1205 11.0447 11.4292 11.3892 11.1779C12.4947 10.3739 13.4925 8.83778 13.4925 7.28725C13.4925 3.51862 10.3915 2.66439 6.45054 2.61415L6.45772 2.62132Z" fill="#575CFF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5261_66931">
                              <rect width="13" height="11.27" fill="white" transform="translate(0.5)" />
                            </clipPath>
                          </defs>
                        </svg></div> <p>Reply via Email : </p></div><div> <p>{currentSession?.companyEmailAddress} </p></div>

                    <div>

                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={handleCloseWindow} >
                        <path d="M9.20122 8.00004L15.0562 2.14454C15.3882 1.81344 15.3882 1.27444 15.0562 0.943336C14.7242 0.611336 14.1851 0.611336 13.855 0.943336L8.00002 6.79874L2.14502 0.943336C1.81492 0.611336 1.27392 0.611336 0.943824 0.943336C0.611824 1.27444 0.611824 1.81344 0.943824 2.14454L6.79882 8.00004L0.943824 13.8555C0.611824 14.1866 0.611824 14.7256 0.943824 15.0567C1.10982 15.2227 1.32662 15.3057 1.54442 15.3057C1.76222 15.3057 1.97992 15.2227 2.14502 15.0567L8.00002 9.20134L13.855 15.0567C14.02 15.2227 14.2378 15.3057 14.4556 15.3057C14.6734 15.3057 14.8902 15.2227 15.0562 15.0567C15.3882 14.7256 15.3882 14.1866 15.0562 13.8555L9.20122 8.00004Z" fill="#757676" />
                      </svg>
                    </div>
                  </div>

                  <div className={` ${styles.neweditor} neweditorinput neweditorinputweb scroller ${mailState.bccState ? "addfromtohight" : ""}`} >

                    {props.sms_email?.[0] === 'email' && <>
                      <div className="chatinputfrom">
                        {(currentSession) &&
                          <div className="editorcc">
                            <label>To</label>
                            <div className="editorccselect">
                              <Select
                                open={false}
                                mode="tags"
                                style={{ width: '100%' }}
                                onChange={onChangeToMailListFun}
                                value={toMailList}
                                options={options}
                                popupClassName="innerdrophidden"
                                className="antSelect nbdrSel"
                              />
                              <div className="ccadd">
                                <p onClick={() => setMailState({ ...mailState, ccState: !mailState.ccState })}>Cc</p>
                                <p onClick={() => setMailState({ ...mailState, bccState: !mailState.bccState })}>Bcc</p>
                              </div>
                            </div>
                            {/* {mailState.ccState && <div className="cctextsecmain"><label onClick={() => mailState.ccState = !mailState.ccState}>Cc</label><label onClick={() => mailState.bccState = !mailState.bccState}>Bcc</label></div>} */}
                          </div>
                        }
                        {mailState.ccState &&

                          <div className="editorcc">
                            <label>Cc</label>
                            <div className="editorccselect">
                              <Select
                                mode="tags"
                                open={false}
                                style={{ width: '100%' }}
                                onChange={handleChangeCC}
                                options={options}
                                value={ccEmail}
                                className="antSelect"
                                popupClassName="innerdrophidden"
                              />
                            </div>
                          </div>
                        }
                        {mailState.bccState &&

                          <div className="editorcc">
                            <label>Bcc</label>
                            <div className="editorccselect">
                              <Select
                                mode="tags"
                                open={false}
                                style={{ width: '100%' }}
                                onChange={handleChangeBCC}
                                options={options}
                                value={bccEmail}
                                className="antSelect"
                                popupClassName="innerdrophidden"
                              />
                            </div>
                          </div>
                        }


                        {(props.sms_email?.[0] === 'email') &&
                          <div className="editorcc forsubjects">
                            <label>Subject :</label>
                            <div className="editorccselect">
                              {props.sms_email?.[0] === 'email'
                                ? <input type="text" id="subject" name="subject" value={subject} onChange={changeSubject}></input>
                                : currentSession.EmailSubject}
                              {error && subject === '' &&
                                <Tooltip placement="top" title="Subject is Required" overlayClassName="customtooltipsmall">
                                  <span className={`icon__Warning20 ${styles.invalidTime}`}></span>
                                </Tooltip>}
                            </div>
                          </div>}
                      </div></>}
                    {attachFile?.length > 0 &&
                      attachFile.map((row: any, index: any) => {
                        return (
                          <div className={styles.chateditorfileBottom}>
                            <div className={styles.left}>
                              {imageFormat.indexOf(row?.mimetype) !== -1 ?
                                <img src={row?.url} alt="" /> :
                                excelFormats.indexOf(row?.mimetype) !== -1 ?
                                  <img src={Excelicon} alt="" /> :
                                  pptFormats.indexOf(row?.mimetype) !== -1 ?
                                    <img src={fileppt} alt="" /> :
                                    wordFormats.indexOf(row?.mimetype) !== -1 ?
                                      <img src={Wordicon} alt="word" /> :
                                      videoFormat.indexOf(row?.mimetype) !== -1 ?
                                        <span className="icon__PlayPrompt20"></span> :
                                        mp3Formats.indexOf(row?.mimetype) !== -1 ?
                                          <span className="icon__WidgetMusic24"></span> :
                                          <img src={Pdficon} alt="word" />
                              }

                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                            <div
                              className={styles.chatmsgclose}
                              onClick={(e: any) => {
                                const data = [...attachFile]
                                data.splice(index, 1)
                                setAttachmentFile([...data])
                              }}
                            ><span className="icon__circleclose16" /></div>
                          </div>
                        )
                      })

                    }

                    <div className={`scroller ${styles.textAreaSec}`} contentEditable="true" id="textedited" onInput={(e: any) => onUpdateMessageCall(e, 'email')} placeholder="Enter Text to send">

                    </div>


                  </div>
                  <div>
                    <div className={`emojitool ${styles.editortool}`}>

                      <div className={styles.editortooliconsnew}>
                        <div className={styles.replydiv}>
                          <Select
                            className={`antSelect ${styles.replayVia}`}
                            placeholder="Reply Via"
                            value={props.sms_email?.[0]?.toUpperCase() || null}
                            popupClassName="antSelectPopover replyselects"

                            suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                              <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676" />
                            </svg>}
                            onChange={(d: any, record: any) => {
                              if (`${currentSession?.calledPersonDetails?.doNotDisturb}` === '1') {
                                sendDNDError()
                              } else if (!props.omniChannelPurchased.emailAddress && !props.omniChannelPurchased.smsNumber && !props.omniChannelPurchased?.callNumber) {
                                props.setSms_email(null)
                                props.setplanPurchaseModel(true)
                              } else if (props.omniChannelPurchased?.smsNumber && record.name === 'sms') {
                                props.setSms_email(['sms', record.value_])
                              } else if (props.omniChannelPurchased.emailAddress && record.name === 'email') {
                                props.setSms_email(['email', record.value_])
                              } else {
                                props.setSms_email(null)
                                props.setplanPurchaseModel(true)
                              }
                            }}>
                            {props.replayViaOptions?.map((data: any) => <Select.Option key={data.key} name={data.name} value_={data.value} >{data.label}</Select.Option>)}
                          </Select>


                        </div>
                        {(props.sms_email?.[0] === 'email') &&

                          <>
                            {inlineStyleButtons.map((button) => {
                              if ((button.style == 'insertOrderedList' || button.style == 'insertUnorderedList')) {
                                return null
                              }
                              return (<button
                                key={button.style}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => boldTextContent(button.style)}
                                className={`${button.style === activeButton?.activeBtn ? styles.active : ""}`}
                              >
                                {button.label}
                              </button>)
                            })}
                            <div className="fileuploadbtn chatbtms">
                              <button >
                                <input
                                  type="file"
                                  accept={currentSession.channelType === "Instagram" ? "image/*,audio/*,video/*" : `${[...wordFormats, ...pptFormats, ...excelFormats, ...imageFormat, ...mp3Formats_, ...videoFormat, ...pdfFormats].join(',')}`} onChange={(currentSession.channelType === "Email") ? changeFile : handleFileUpload}
                                  onClick={(event: any) => {
                                    event.currentTarget.value = null;
                                  }}
                                  multiple={true}
                                />
                              </button>
                              <p>
                                <img src={chatattachfont} alt="file" />
                                {/* <span className={styles.fileName}>{filename}</span> */}
                              </p>
                            </div></>}

                        <div className={`${styles.right}`}>


                          {(props.sms_email?.[0] === 'email') &&

                            <>




                              <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                                onClick={sendOutBoundEmailForCaLL}>
                                <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                                <g clip-path="url(#clip0_3704_51491)">
                                  <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3704_51491">
                                    <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </>
                          }



                        </div>

                      </div>
                    </div>
                  </div></>
                }
                {props.sms_email?.[0] === 'sms' && <>
                  <div className={`${styles.rplyviacont} ${styles.replyviacontnew}`}>
                    <div className={styles.replyshareblock}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" >
                          <g clip-path="url(#clip0_5261_66931)">
                            <path d="M6.45772 2.62132C6.44336 1.80299 6.40747 1.20001 6.27826 0.790844C6.18494 0.50371 6.04855 0.302716 5.84756 0.180684C5.45275 -0.0562018 5.00769 -0.0490234 4.6057 0.166327C4.03143 0.474996 3.29924 1.16412 2.20813 2.21216L1.6554 2.74336C0.930384 3.43248 0.564288 3.77704 0.506861 4.19338C0.492505 4.29388 0.492505 4.40156 0.506861 4.50205C0.564288 4.9184 0.923206 5.26296 1.64822 5.95926L2.20095 6.49046C3.32795 7.56721 4.06015 8.27069 4.64877 8.55782C5.2374 8.85214 5.98395 8.65832 6.22801 8.02662C6.39311 7.6031 6.43618 6.95705 6.45054 6.03104C10.1976 6.12436 11.8056 7.12933 10.6786 10.7113C10.5494 11.1205 11.0447 11.4292 11.3892 11.1779C12.4947 10.3739 13.4925 8.83778 13.4925 7.28725C13.4925 3.51862 10.3915 2.66439 6.45054 2.61415L6.45772 2.62132Z" fill="#575CFF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5261_66931">
                              <rect width="13" height="11.27" fill="white" transform="translate(0.5)" />
                            </clipPath>
                          </defs>
                        </svg></div> <p>Reply via Sms :</p><p>{currentSession?.companySMSNumber} </p></div> 
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={handleCloseWindow} >
                        <path d="M9.20122 8.00004L15.0562 2.14454C15.3882 1.81344 15.3882 1.27444 15.0562 0.943336C14.7242 0.611336 14.1851 0.611336 13.855 0.943336L8.00002 6.79874L2.14502 0.943336C1.81492 0.611336 1.27392 0.611336 0.943824 0.943336C0.611824 1.27444 0.611824 1.81344 0.943824 2.14454L6.79882 8.00004L0.943824 13.8555C0.611824 14.1866 0.611824 14.7256 0.943824 15.0567C1.10982 15.2227 1.32662 15.3057 1.54442 15.3057C1.76222 15.3057 1.97992 15.2227 2.14502 15.0567L8.00002 9.20134L13.855 15.0567C14.02 15.2227 14.2378 15.3057 14.4556 15.3057C14.6734 15.3057 14.8902 15.2227 15.0562 15.0567C15.3882 14.7256 15.3882 14.1866 15.0562 13.8555L9.20122 8.00004Z" fill="#757676" />
                      </svg>
                    </div>
                  </div>
                  <div className={`neweditorinput neweditorinputweb scroller ${mailState.bccState ? "addfromtohight" : ""}`} >
                    <div className={`scroller ${styles.textAreaSec}`} contentEditable="true" id="textedited" onInput={(e: any) => onUpdateMessageCall(e, 'sms')} placeholder="Enter Text to send">

                    </div>
                  </div>
                  <div className={`emojitool ${styles.editortool}`}>

                    <div className={styles.editortooliconsnew}>
                      <div className={styles.replydiv}>
                        <Select
                          className={`antSelect ${styles.replayVia}`}
                          placeholder="Reply Via"
                          value={props.sms_email?.[0]?.toUpperCase() || null}
                          popupClassName="antSelectPopover replyselects"

                          suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                            <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676" />
                          </svg>}
                          onChange={(d: any, record: any) => {
                            if (`${currentSession?.calledPersonDetails?.doNotDisturb}` === '1') {
                              sendDNDError()
                            } else if (!props.omniChannelPurchased.emailAddress && !props.omniChannelPurchased.smsNumber && !props.omniChannelPurchased?.callNumber) {
                              props.setSms_email(null)
                              props.setplanPurchaseModel(true)
                            } else if (props.omniChannelPurchased?.smsNumber && record.name === 'sms') {
                              props.setSms_email(['sms', record.value_])
                            } else if (props.omniChannelPurchased.emailAddress && record.name === 'email') {
                              props.setSms_email(['email', record.value_])
                            } else {
                              props.setSms_email(null)
                              props.setplanPurchaseModel(true)
                            }
                          }}>
                          {props.replayViaOptions?.map((data: any) => <Select.Option key={data.key} name={data.name} value_={data.value} >{data.label}</Select.Option>)}
                        </Select>
                      </div>


                      <div className={`${styles.right}`}>

                        {(props.sms_email?.[0] === 'sms') &&
                          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={sendOutBoundSMSForCall}>
                            <rect x="0.804688" y="0.953125" width="28" height="28" rx="14" fill="#000" />
                            <g clip-path="url(#clip0_3704_51491)">
                              <path d="M21.1924 9.61016C20.9242 9.33803 20.5199 9.24883 20.1615 9.37969L8.80769 13.4897C8.44309 13.6154 8.19149 13.9311 8.15076 14.3133C8.11069 14.6883 8.28289 15.0412 8.58956 15.2267L10.6195 16.5372C10.8636 16.6922 11.1807 16.6968 11.4274 16.5457L18.3203 12.0306L11.8669 17.1609C11.7331 17.2755 11.643 17.4344 11.613 17.6062L11.3154 19.2911C11.2409 19.713 11.4248 20.1179 11.7845 20.3236C12.1426 20.528 12.5781 20.487 12.8948 20.2156L14.3766 18.9448L16.6524 20.4324C16.8096 20.5352 16.9942 20.588 17.1807 20.588C17.2927 20.588 17.4056 20.5691 17.5137 20.53C17.8034 20.4252 18.0215 20.1974 18.1065 19.9213L21.3982 10.6146C21.5352 10.2637 21.4564 9.87836 21.1924 9.61016Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3704_51491">
                                <rect width="16" height="16" fill="white" transform="translate(6.80469 6.95312)" />
                              </clipPath>
                            </defs>
                          </svg>
                        }




                      </div>
                    </div>

                  </div>
                </>}
                {props.sms_email?.[0] == null && <div className="neweditor neweditoremail callBackReply">
                  <div className={styles.replydiv}>
                    <Select
                      className={`antSelect ${styles.replayVia}`}
                      placeholder="Reply Via"
                      value={props.sms_email?.[0]?.toUpperCase() || null}
                      popupClassName="antSelectPopover replyselects"

                      suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                        <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676" />
                      </svg>}
                      onChange={(d: any, record: any) => {
                        if (`${currentSession?.calledPersonDetails?.doNotDisturb}` === '1') {
                          sendDNDError()
                        } else if (!props.omniChannelPurchased.emailAddress && !props.omniChannelPurchased.smsNumber && !props.omniChannelPurchased?.callNumber) {
                          props.setSms_email(null)
                          props.setplanPurchaseModel(true)
                        } else if (props.omniChannelPurchased?.smsNumber && record.name === 'sms') {
                          props.setSms_email(['sms', record.value_])
                        } else if (props.omniChannelPurchased.emailAddress && record.name === 'email') {
                          props.setSms_email(['email', record.value_])
                        } else {
                          props.setSms_email(null)
                          props.setplanPurchaseModel(true)
                        }
                      }}>
                      {props.replayViaOptions?.map((data: any) => <Select.Option key={data.key} name={data.name} value_={data.value} >{data.label}</Select.Option>)}
                    </Select>
                  </div>
                  <span className={styles.transText}>Transcription...</span>
                </div>}

              </div>

            }
            {loader && <Loaders />}
          </>}
    </>
  );
};

export default ChatEditorBottom;